import React from 'react';
import { Page } from '../Page';
import { Logo } from '../Logo';
export function Page12() {
  return <Page hideFooter variant="dark" data-id="element-581">
      <div className="flex-1 flex items-center justify-center" data-id="element-582">
        <Logo className="w-[230px] h-[230px] object-contain opacity-90" data-id="element-583" />
      </div>
    </Page>;
}